import { ArrayUtils } from '@everyboard/lib';
import { EpaminondasMoveGenerator } from './EpaminondasMoveGenerator';
export class EpaminondasPhalanxSizeAndFilterMoveGenerator extends EpaminondasMoveGenerator {
    getListMoves(node, config) {
        const moves = super.getListMoves(node, config);
        return this.orderMovesByPhalanxSizeAndFilter(moves, node.gameState);
    }
    orderMovesByPhalanxSizeAndFilter(moves, state) {
        ArrayUtils.sortByDescending(moves, (move) => {
            return move.phalanxSize;
        });
        return moves.slice(0, 40); // Keep at most 40 moves
    }
}
